import Bridge from '@/frontend-lib/lib/Bridge';
import {getPlatform} from '@/frontend-lib/tools/getPlatform';

let platform = getPlatform();
let myBridge = new Bridge();
let reloaded = 0;
export function relaodWebView() {
  reloaded = reloaded | window.localStorage.getItem('yxl_kdxlApp_reloaded');
  if (platform.isCeShiApp && !reloaded) {
    reloaded = 1;
    window.localStorage.setItem('yxl_kdxlApp_reloaded', 1);
    // window.addEventListener('storage', function(e){
    console.log('刷新页面, 当前页面地址', window.location.href, reloaded);
    myBridge.call('reloadAllWebView', {currentUrl: window.location.href});
    // });
  } else {
    reloaded = 0;
  }
}

export function removeReloadTag() {
  reloaded = 0;
  window.localStorage.removeItem('yxl_kdxlApp_reloaded');
}

export function removeTopbar() {
  if (platform.isCeShiApp && document.querySelector('.topbar')) {
    document.querySelector('.topbar').remove();
  }
}

export function setGoBackCancelWebView ({allowed = 0}) {
  let myBridge = new Bridge({
    methods: [
      {
        method: 'goBack',
        callback: function () {
          myBridge.call('cancelWebView');
        }
      }]
  });
  if (platform.isCeShiApp) {
    myBridge.call('allowJSControlGoback', {
      isAllowed: allowed
    });
  }
}
export default {
  removeReloadTag,
  relaodWebView,
  removeTopbar,
  setGoBackCancelWebView
};



// WEBPACK FOOTER //
// ./src/util/xinliceshiApp.js